import { createToastMessage, useToastMessages } from './toaster';
import uiActions from '../../../models/ui/actions';
import { useCallback, useEffect } from 'react';
import { usePatronSelector } from '../../../common/use-patron-selector';

//subset of ToastMessageType that is also compatible with flashMessage (now removed)
export type LegacyMessageType = {
  type: 'success' | 'warning' | 'error';
  text: string;
  timeout?: number | false;
};

/**
 * to be used as long as we have the newUIEnabled feature flag. Handles selecting the right interface for the deprecated flashMessages and the new toaster.
 * should be able to convert all usages of usePushToastOrFlashMessage to useToastMessages in the future with minimal hassle.
 * @deprecated, to be replaced by solar toasts. We might need to keep this around as long as we support the old ui.
 * TODO: remove it, the flag has been removed, next step is to use the new toaster everywhere.
 */
export const usePushToastOrFlashMessage = () => {
  const { setToastMessage } = useToastMessages();

  const pushMessage = useCallback(
    (message: LegacyMessageType) => {
      setToastMessage(createToastMessage(message));
    },
    [setToastMessage]
  );

  return {
    pushMessage,
  };
};

//the next two items are specifically for cases when a redux action wants to set a toast message. redux does not have access to hooks, so we need to use this shim to set the toast message.
//components should not try to use this directly, but instead use usePushToastOrFlashMessage, as it handles multiple messages properly and is a lot less hacky.

/**
 * @deprecated, to be replaced by solar toasts. We might need to keep this around as long as we support the old ui.
 */
export const dispatchToastOrFlashMessage = (
  message: LegacyMessageType,
  dispatch: any
) => {
  dispatch(uiActions.setToastMessage(message));
};

/**
 * @deprecated, to be replaced by solar toasts. We might need to keep this around as long as we support the old ui.
 */
export const ToasterReduxShim: React.FC = () => {
  const { setToastMessage } = useToastMessages();
  const toastMessage = usePatronSelector((state) => state.ui.toastMessageShim);

  //whenever the shim state is updated, push that new message to the toaster
  useEffect(() => {
    if (toastMessage) {
      setToastMessage(createToastMessage(toastMessage));
    }
  }, [toastMessage, setToastMessage]);

  return null;
};
